import { HeroSection } from './HeroSection';
import { TextSection } from './TextSection';
import { ImageSection } from './ImageSection';
import { TextImageSection } from './TextImageSection';
import { FeaturesSection } from './FeaturesSection';
import { CTASection } from './CTASection';
import { TestimonialsSection } from './TestimonialsSection';
import { GallerySection } from './GallerySection';
import { ServicesSection } from './ServicesSection';
import { StatsSection } from './StatsSection';
import { SpacerSection } from './SpacerSection';
import { VideoSection } from './VideoSection';
import { ReviewFormSection } from './ReviewFormSection';

export interface SectionData {
  id: string;
  section_type: string;
  content: Record<string, unknown>;
  layout_variant: string;
  is_visible: boolean;
  sort_order: number;
}

interface SectionRendererProps {
  section: SectionData;
  layoutStyle?: string;
  /** Rendering inside the page builder — interactive blocks (forms) must not submit. */
  preview?: boolean;
}

export function SectionRenderer({ section, layoutStyle = 'classic', preview = false }: SectionRendererProps) {
  if (!section.is_visible) return null;

  // Each section component declares its own content shape; section.content is loose JSON,
  // so cast to an empty record (assignable to every section's content prop) when spreading.
  const props = {
    content: section.content as Record<string, never>,
    variant: section.layout_variant,
    layoutStyle,
  };

  switch (section.section_type) {
    case 'hero':
      return <HeroSection {...props} />;
    case 'text':
      return <TextSection {...props} />;
    case 'image':
      return <ImageSection {...props} />;
    case 'text_image':
      return <TextImageSection {...props} />;
    case 'features':
      return <FeaturesSection {...props} />;
    case 'cta':
      return <CTASection {...props} />;
    case 'testimonials':
      return <TestimonialsSection {...props} />;
    case 'gallery':
      return <GallerySection {...props} />;
    case 'services':
      return <ServicesSection {...props} />;
    case 'stats':
      return <StatsSection {...props} />;
    case 'spacer':
      return <SpacerSection {...props} />;
    case 'video':
      return <VideoSection {...props} />;
    case 'review_form':
      return <ReviewFormSection {...props} preview={preview} />;
    default:
      return null;
  }
}
